<template>
    <form action="" @submit.prevent="authenticate">
         <b-modal :active="true" :canCancel="false" :width="640" scroll="keep">
           <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Login</p>
                </header>
                <section class="modal-card-body">
                    <b-field label="Email">
                        <b-input
                            type="email"
                            v-model="email"
                            placeholder="Your email"
                            required>
                        </b-input>
                    </b-field>

                    <b-field label="Password">
                        <b-input
                            type="password"
                            v-model="password"
                            password-reveal
                            placeholder="Your password"
                            required>
                        </b-input>
                    </b-field>

                    <b-checkbox v-model="remember">Stay Signed In</b-checkbox>
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-primary">Login</button>
                </footer>
            </div>
        </b-modal>
    </form>
</template>

<script>
import { LOG_IN } from "@/store/actions";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      remember: false
    };
  },
  methods: {
    authenticate() {
      console.log("Authenticate");
      const { email, password, remember } = this;
      this.$store
        .dispatch(LOG_IN, { email, password, remember })
        .then(res => {
          this.$success("Successfully logged in");
          this.$router.push('/');
        })
        .catch(err => {
          if (err.message && err.message.indexOf("422") >= 0) {
            this.$warning(
              "Failed to log in, please check your username and password and try again"
            );
          } else {
            this.$error("Something went wrong, please try again");
          }
        });
    }
  }
};
</script>
